module.exports = __webpack_public_path__ + "static/media/gogoabout.a6b22cc9.png";